import { AudienceStatus } from './AudienceStatus';
import { EmailTemplateType } from './EmailTemplateType';
import { IAction } from './IAction';
import { IAudience } from './IAudience';
import { IEmailTemplate } from './IEmailTemplate';
import { ISurveyAdminSummary } from './ISurveyAdminSummary';
import { ISurveyPreviewModel } from './ISurveyPreviewModel';
import { SurveyStep } from './SurveyStep';

export const audienceTemplate: IAudience = {
	audienceId: 0,
	audienceName: '',
	clientId: 0,
	surveyId: 0,
	openImmediately: false,
	audienceStatus: AudienceStatus.Incomplete,
	isTestAudience: false,
};

export const emailTemplateTemplate: IEmailTemplate = {
	emailTemplateId: 0,
	emailTemplateName: '',
	audienceId: 0,
	invitationType: EmailTemplateType.Reminder,
	from: '',
	replyToEmail: '',
	subject: '',
	content: '',
	createdOn: undefined,
	uniqueId: '1',
	action: IAction.None,
};

export const surveyAdminSummaryTemplate: ISurveyAdminSummary = {
	surveyId: 1,
	hasBeenPublished: false,
	summaryItems: [],
	audienceSummaryItem: undefined,
};

export const surveyPreviewTemplate: ISurveyPreviewModel = {
	currentStep: SurveyStep.Admin,
	previewUrl: '',
	canPreviewSurvey: true,
};
